// LIBS
import React from 'react'
import {Helmet} from 'react-helmet'

// INTERFACE
export default class Disqus extends React.Component {
  disqusReset = () => {
    let {identifier, title} = this.props
    if(window.DISQUS){
      window.DISQUS.reset({
        reload: true,
        config: function () { // must not be arow function 
          this.page.identifier = identifier
          this.page.title = title
          this.page.url = window.location.origin + window.location.pathname
          this.page.category_id = 'blog'
          this.callbacks.onNewComment = [(comment) => {
            // TODO: ADD GOOGLE ANALYTICS HERE
          }]
        },
      })
    }
  }

  componentDidMount(props) {
    if (!window.DISQUS) {
      this.disqusReset()
    } else {
      // the script with id="disqus-script" is at the bottom of src/html.js
      document.getElementById('disqus-script')
        .addEventListener('load', () => this.disqusReset())
    }
  }

  render () {
    return (
      <div>
        <Helmet>
          <script id='disqus-script' src='https://code-fellows.disqus.com/embed.js' async />
        </Helmet>
        <div id="disqus_thread"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/disqus/index.js